// 过滤出对象中不相等的键值对
export function ObjectChangedValue(obj1, obj2) {
  let keys = Object.keys(obj1);
  let result = {};
  keys.forEach((k) => {
    if (obj1[k] != obj2[k]) {
      result[k] = obj2[k];
    }
  });
  return result;
}
export function GetUser() {
  return new Promise((resolve, reject) => {
    this.$get("user/coach/findById", {
      id: localStorage.getItem("coach_id"),
    }).then((res) => {
      if (res.data.code == 0) {
        resolve(res.data.data);
      } else
        this.$message({
          showClose: true,
          message: res.data.message,
          type: "error",
        });
    });
  });
}



export function Ts(message, ts) {
  if (ts) {
    this.$message({
      message: message,
      type: "success",
    });
  } else {
    this.$message.error(message);
  }
  return;
}
